import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

const swiper = {
    calculateSlidesPerView(swiperElement) {
        const windowWidth = window.innerWidth;
        const sliderWidth = swiperElement.offsetWidth;
        
        // Force 1 slide on smaller than MD screens
        if (windowWidth < 768) {
            return 1.15;
        }
        
        // Calculate ratio - bigger screen relative to slider = show less slides
        const ratio = windowWidth / sliderWidth;
        
        // Base slides per view - smaller when screen is bigger relative to slider
        const baseSlidesPerView = Math.max(1.1, Math.min(2.5 / ratio, 3));
        
        return baseSlidesPerView;
    },
    config: {
        default: {
            modules: [Navigation, Pagination, Autoplay],
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
        },
        imageCarouselAlt: {
            modules: [Navigation, Pagination],
            loop: true,
            centeredSlides: true,
            spaceBetween: 16,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
        },
    },
    activeSwipers: [],
    calculateCarouselHeight(swiperElement) {
        const slides = swiperElement.querySelectorAll('.swiper-slide[data-aspect-ratio]');
        if (slides.length === 0) return 50; // Default to 50vh

        let maxAspectRatio = 0;
        slides.forEach(slide => {
            const aspectRatio = parseFloat(slide.dataset.aspectRatio);
            if (aspectRatio > maxAspectRatio) {
                maxAspectRatio = aspectRatio;
            }
        });

        if (maxAspectRatio === 0) return 50;

        const viewportWidth = window.innerWidth;
        let horizontalMargin = 0;

        if (viewportWidth < 1090) {
            horizontalMargin = 30 * 2; // 1.875rem * 2
        } else if (viewportWidth < 1260) {
            horizontalMargin = 60 * 2; // 3.75rem * 2
        } else if (viewportWidth < 1620) {
            horizontalMargin = 80 * 2; // 5rem * 2
        } else {
            horizontalMargin = (viewportWidth * 0.1) * 2; // 10vw * 2
        }

        const availableWidth = viewportWidth - horizontalMargin;
        const viewportHeight = window.innerHeight;
        const maxHeight = (availableWidth / maxAspectRatio) * 100 / viewportHeight;
        const maxHeightVh = Math.min(maxHeight, 50); // Cap at 50vh

        return maxHeightVh;
    },
    updateCarouselHeight(swiperElement) {
        const heightVh = this.calculateCarouselHeight(swiperElement);
        swiperElement.style.setProperty('--carousel-height', `${heightVh}vh`);
    },
    init() {
        const self = this;

        const swiperElements = document.querySelectorAll('.swiper')
        if (swiperElements.length === 0) return;

        swiperElements.forEach(swiperElement => { 
            const handle = swiperElement.dataset.swiperHandle ?? 'default';
            const config = { ...this.config[handle] };
            
            const thisSwiper = new Swiper(swiperElement, config);
            
            if (handle === 'imageCarouselAlt') {
                const updateHeight = () => {
                    self.updateCarouselHeight(swiperElement);
                    thisSwiper.update();
                };
                
                updateHeight();
                
                window.addEventListener('resize', () => {
                    updateHeight();
                });
            }
            
            self.activeSwipers.push(thisSwiper);
        });
    },
};

export default swiper;
